"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStyles = void 0;
const react_1 = require("react");
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const create_use_styles_1 = __importDefault(require("./create-use-styles"));
const theme_provider_1 = require("./theme-provider");
const createUseGlobalStyles = (overrides) => (0, create_use_styles_1.default)(theme => ({
    "@global": (0, lodash_merge_1.default)({
        "*, *::before, *::after": {
            boxSizing: "border-box",
        },
        "html": {
            fontSize: theme.typography.baseFontSize,
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
        },
        "body": {
            margin: 0,
            ...theme.typography.body,
            color: theme.colors.text,
            backgroundColor: theme.colors.background,
        },
        "h1": theme.typography.h1,
        "h2": theme.typography.h2,
        "h3": theme.typography.h3,
        "h4": theme.typography.h4,
        "h5": theme.typography.h5,
        "h6": theme.typography.h6,
        "small": theme.typography.small,
        "label": theme.typography.label,
        "code": theme.typography.code,
    }, overrides),
}));
const defaultOverrides = () => ({});
function GlobalStyles({ overrides = defaultOverrides }) {
    const { theme } = (0, theme_provider_1.useTheme)();
    const result = (0, react_1.useMemo)(() => overrides(theme), [overrides, theme]);
    const useGlobalStyles = (0, react_1.useMemo)(() => createUseGlobalStyles(result), [result]);
    useGlobalStyles();
    return null;
}
exports.GlobalStyles = GlobalStyles;
exports.default = GlobalStyles;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2xvYmFsLXN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3RoZW1pbmcvZ2xvYmFsLXN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxpQ0FBZ0M7QUFDaEMsZ0VBQWlDO0FBR2pDLDRFQUFrRDtBQUNsRCxxREFBNEM7QUFFNUMsTUFBTSxxQkFBcUIsR0FBRyxDQUFDLFNBQThCLEVBQUUsRUFBRSxDQUMvRCxJQUFBLDJCQUFlLEVBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFDO0lBQ3hCLFNBQVMsRUFBRSxJQUFBLHNCQUFLLEVBQ2Q7UUFDRSx3QkFBd0IsRUFBRTtZQUN4QixTQUFTLEVBQUUsWUFBWTtTQUN4QjtRQUNELE1BQU0sRUFBRTtZQUNOLFFBQVEsRUFBRSxLQUFLLENBQUMsVUFBVSxDQUFDLFlBQVk7WUFDdkMsbUJBQW1CLEVBQUUsYUFBYTtZQUNsQyxtQkFBbUIsRUFBRSxXQUFXO1NBQ2pDO1FBQ0QsTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLENBQUM7WUFDVCxHQUFHLEtBQUssQ0FBQyxVQUFVLENBQUMsSUFBSTtZQUN4QixLQUFLLEVBQUUsS0FBSyxDQUFDLE1BQU0sQ0FBQyxJQUFJO1lBQ3hCLGVBQWUsRUFBRSxLQUFLLENBQUMsTUFBTSxDQUFDLFVBQVU7U0FDekM7UUFDRCxJQUFJLEVBQUUsS0FBSyxDQUFDLFVBQVUsQ0FBQyxFQUFFO1FBQ3pCLElBQUksRUFBRSxLQUFLLENBQUMsVUFBVSxDQUFDLEVBQUU7UUFDekIsSUFBSSxFQUFFLEtBQUssQ0FBQyxVQUFVLENBQUMsRUFBRTtRQUN6QixJQUFJLEVBQUUsS0FBSyxDQUFDLFVBQVUsQ0FBQyxFQUFFO1FBQ3pCLElBQUksRUFBRSxLQUFLLENBQUMsVUFBVSxDQUFDLEVBQUU7UUFDekIsSUFBSSxFQUFFLEtBQUssQ0FBQyxVQUFVLENBQUMsRUFBRTtRQUN6QixPQUFPLEVBQUUsS0FBSyxDQUFDLFVBQVUsQ0FBQyxLQUFLO1FBQy9CLE9BQU8sRUFBRSxLQUFLLENBQUMsVUFBVSxDQUFDLEtBQUs7UUFDL0IsTUFBTSxFQUFFLEtBQUssQ0FBQyxVQUFVLENBQUMsSUFBSTtLQUM5QixFQUNELFNBQVMsQ0FDVjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRU4sTUFBTSxnQkFBZ0IsR0FBRyxHQUFHLEVBQUUsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDO0FBRXBDLFNBQWdCLFlBQVksQ0FBQyxFQUFFLFNBQVMsR0FBRyxnQkFBZ0IsRUFBd0Q7SUFDakgsTUFBTSxFQUFFLEtBQUssRUFBRSxHQUFHLElBQUEseUJBQVEsR0FBRSxDQUFDO0lBQzdCLE1BQU0sTUFBTSxHQUFHLElBQUEsZUFBTyxFQUFDLEdBQUcsRUFBRSxDQUFDLFNBQVMsQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLFNBQVMsRUFBRSxLQUFLLENBQUMsQ0FBQyxDQUFDO0lBQ25FLE1BQU0sZUFBZSxHQUFHLElBQUEsZUFBTyxFQUFDLEdBQUcsRUFBRSxDQUFDLHFCQUFxQixDQUFDLE1BQU0sQ0FBQyxFQUFFLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQztJQUUvRSxlQUFlLEVBQUUsQ0FBQztJQUVsQixPQUFPLElBQUksQ0FBQztBQUNkLENBQUM7QUFSRCxvQ0FRQztBQUVELGtCQUFlLFlBQVksQ0FBQyJ9